<template>
  <gg-modal :is-active="isActive" @close="closeModal">
    <template v-slot:toolbar>
      Change Quota
    </template>
    <template v-slot:body>
      <v-row>
        <v-col cols="10">
          <v-slider outlined
                    v-model="value"
                    name="Quota"
                    :error-messages="errors.collect('Quota')"
                    type="number"
                    label="New quota value"
                    hide-details
                    max="10000"
                    min="1"
          >
          </v-slider>
        </v-col>
        <v-col cols="2">
          {{ value }} MB
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="closeModal">
        Cancel
      </gg-btn>
      <gg-btn primary :loading="query_loading" @click="setQuota">
        Save Changes
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangeQuota',
  data: () => ({
    value: '1024',
    query_loading: false
  }),
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    user: {
      type: String,
      required: true
    },
    domain: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      changeQuota: 'email/changeQuota',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    setUnlimited () {
      this.value = '0'
    },
    async setQuota () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.query_loading = true
      let params = {
        email: this.user,
        domain: this.domain,
        quota: this.value,
        _username: this.$route.query.user,
      }
      try {
        await this.changeQuota(params)
        this.query_loading = false
        this.reportSuccess('Quota successfully changed')
        this.closeModal()
        this.actionCompleted()
      } catch (e) {
        this.query_loading = false
        this.reportError(e)
      }
    },
    closeModal () {
      this.$emit('close')
    },
    actionCompleted () {
      this.$emit('action-completed')
    }
  }
}
</script>
